// extracted by mini-css-extract-plugin
export default {"l_LabelAndContentContainer_main":"LabelAndContentContainer_l_LabelAndContentContainer_main__rJcu1"};